/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import sirepAPI from "@/api/sirepApi";
import sirepApiFiles from "@/api/sirepApiFiles"

export const sendAddtransferDeparture = async({ commit }, form)=>{
    try {
        let{dato, params, tipo}=form
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento;
        let{id_person, id_order}=params;
        let type = tipo;
        const {data} = await sirepAPI.post("/adicion_traslado_salidas/enviar_adicion_traslado_salida/"+ userLogged +  "/" + id_person.value + "/" + id_order.value + "/" + type.value, dato)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
    
}
export const getList = async({ commit }, params)=>{
    try {
        let{type_list, id_penitentiary_center, departamento_supervisar}=params
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/lista_traslados_salidas" + "/" + id_penitentiary_center.value + "/" + type_list + "/" + departamento_supervisar.value)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
    
}
export const uploadFile = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/adicion_traslado_salidas/uploadFile/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const uploadFileRevocation = async({commit}, id) =>{
    const formData = new FormData();
        formData.append('uploaded_file', id[0]);
    try {
        var ext = id[0].name.split('.').pop();
                if(ext!=='pdf' && ext!=='PDF'){
                    alert("error")
                    return false
                  }
        //let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepApiFiles.post("/adicion_traslado_salidas/uploadFileRevocation/"+ id[1], formData)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const printResolution = ({commit}, id) => {
        try {
            // const resp =  open("http://localhost:3012/adicion_traslado_salidas/view_file/"+id)
            const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/adicion_traslado_salidas/view_file/"+id)
            return resp
        } catch (error) {
            return {message:error}
        }
}
export const printResolutionRevocation = ({commit}, id) => {
    try {
        // const resp =  open("http://localhost:3012/adicion_traslado_salidas/view_file_revocation/"+id)
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/adicion_traslado_salidas/view_file_revocation/"+id)
        return resp
    } catch (error) {
        return {message:error}
    }
}
export const deleteFile = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/delete_file/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const deleteFileRevocation = async({commit}, id) =>{
    try {
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/delete_file_revocation/"+ id)
         return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const receive_transfer = async({commit},datos) => {
    const{id_transfer, id_order, new_cod } = datos;
    try {
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.post("/adicion_traslado_salidas/recibir_transferencia" + "/" + userLogged + "/" + id_transfer + "/" +id_order+ "/" +new_cod)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const get_dataOrders_ppl = async({commit},info) => {
    try {
        const{cod_persona, tipo}=info
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/informacion_ordenes_judiciales" + "/" + cod_persona  + "/" + tipo)
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }
}
export const approve_liberty_ppl = async({commit},id_traslado_salida)=>{
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/aprobar_salida_definitiva"+"/" + userLogged + "/" +id_traslado_salida) 
        return {data} 
    } catch (error) {
        return {message:error}
    }    
};
export const deny_liberty_ppl = async({commit},data)=>{
    let{detalle, id_traslado_salida}=data
    let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
    try {
        const {data} = await sirepAPI.post("/adicion_traslado_salidas/negar_salida_definitiva"+"/" + userLogged + "/" +id_traslado_salida, { detalle }) 
        return {data} 
    } catch (error) {
        return {message:error}
    }    
};
export const turn_principal_order = async({commit},data)=>{
    let{id_orden_judicial,id_persona}=data
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/convertir_orden_principal"+"/" + id_orden_judicial + "/" +id_persona) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const print_add_transfer_departure = ({commit}, data) => {
    const{id, tipo}=data
    try {
        // const resp =  open("http://localhost:3012/adicion_traslado_salidas/view_add_transfer_departure/"+ id + "/" + tipo)
        const resp =  open("https://api.mingobierno.gob.bo/siregpenapi/adicion_traslado_salidas/view_add_transfer_departure/"+ id + "/" + tipo)
        return resp
    } catch (error) {
        return {message:error}
    }
}
export const repeal_order = async({commit},id)=>{
    try {
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/revocar_orden/"+id) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const register_order_departure = async({commit},ids)=>{
    try {
        const{id_traslado_salida, id_persona, id_orden}=ids
        let userLogged= JSON.parse(localStorage.getItem('user')).nro_documento
        const {data} = await sirepAPI.patch("/adicion_traslado_salidas/registrar_orden_salida_definitiva_sin_salida/" + id_persona + "/" + id_orden + "/" + id_traslado_salida + "/" + userLogged) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
export const get_types_of_deaths = async({ commit }, params)=>{
    try {
        const {data} = await sirepAPI.get("/adicion_traslado_salidas/lista_tipos_decesos")
        // commit("listPrivatedLibertyPersons",{data})
       return {data} 
    } catch (error) {
        return {message:error}
    }  
}
export const send_recapture = async({commit},datos)=>{
    const{id, fecha_recaptura, id_persona}=datos
    try {
        const {data} = await sirepAPI.put("/adicion_traslado_salidas/registrar_recaptura/"+ id +"/"+ id_persona, {fecha_recaptura}) 
        return {data} 
    } catch (error) {
        return {message:error}
    }
};
